@if (items.length > 0) {
  <div class="bg-white rounded-xl shadow-sm p-4">
    <h3 class="text-sm font-semibold text-[#023E42] mb-3">
      {{ 'home.gdd.title' | translate }}
    </h3>

    @for (item of visibleItems; track item.plantUid) {
      <div class="flex items-center gap-3 py-2 cursor-pointer" (click)="onPlantClick(item)">
        <!-- Plant info -->
        <div class="flex-1 min-w-0">
          <div class="flex items-center justify-between mb-1">
            <p class="text-xs font-medium text-[#023E42] truncate">{{ item.cultivationName }}</p>
            <vw-gdd-badge [conditionBadge]="item.conditionBadge"></vw-gdd-badge>
          </div>

          <vw-progress-bar [singleColor]="true" [progress]="progressPercent(item.progress)"></vw-progress-bar>

          <div class="flex items-center justify-between mt-1 text-[10px] text-[#6B7280]">
            <span>{{ progressPercent(item.progress) }}% — {{ item.currentStepName }}</span>
            @if (item.estimatedDaysLeft != null) {
              <span>~{{ estimatedDate(item.estimatedDaysLeft) | date:'dd MMM' }}</span>
            }
          </div>
        </div>
      </div>
    }
  </div>
}
